export default "__VITE_ASSET__w7IrcmH6__"